/**
 * UTF-8 Encoding.
 *
 * @public
 */
export const UTF_8 = 'utf-8'
